import axios from 'axios'
import { baseUrl } from './config'

export function getGamesStatus () {
  return axios.get(`${baseUrl}/games`)
}

export function getGames () {
  const params = {
    limit: 50,
    offset: 0,
    sort: 'count_rounds:desc'
  }

  return axios.get(`${baseUrl}/external-games/weight`, { params })
}

export function searchExternalGames (searchString, limit = 5, offset = 0) {
  const params = {
    limit,
    offset,
    search: searchString,
    sort: 'title:asc'
  }

  return axios.get(`${baseUrl}/external-games`, { params })
}

export function changeGamesOrder (id, params) {
  return axios.put(`${baseUrl}/external-games/${id}/weight`, params)
}

export function deleteGame (id) {
  return axios.delete(`${baseUrl}/external-games/${id}/weight`)
}

export function syncProviders () {
  return axios.post(`${baseUrl}/external-providers/sync`)
}

export function syncSoftswissGames () {
  return axios.post(`${baseUrl}/softswiss-games/sync`)
}

export function syncPragmaticGames () {
  return axios.post(`${baseUrl}/pragmatic-games/sync`)
}
